import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useI18n } from '../../i18n';
import { useEmail } from '../../context/EmailContext';
import { notify } from '../CustomToast';
import { FaTimes } from 'react-icons/fa';
import trashIcon from '../../assets/trash.svg';
import '../Projects/ProjectComposer.css';
import '../Projects/DeleteProjectModal.css';
import {
  FaSync,

  FaChevronDown,
  FaChevronUp,
} from 'react-icons/fa';

const InboxIcon = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.3327 10H13.3327L11.666 12.5H8.33268L6.66602 10H1.66602" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.54102 4.25313L1.66602 9.99479V14.9948C1.66602 15.4368 1.84161 15.8607 2.15417 16.1733C2.46673 16.4859 2.89065 16.6615 3.33268 16.6615H16.666C17.108 16.6615 17.532 16.4859 17.8445 16.1733C18.1571 15.8607 18.3327 15.4368 18.3327 14.9948V9.99479L15.4577 4.25313C15.3197 3.97545 15.107 3.74177 14.8435 3.57836C14.58 3.41495 14.2761 3.32829 13.966 3.32812H6.03268C5.72261 3.32829 5.41874 3.41495 5.15522 3.57836C4.8917 3.74177 4.679 3.97545 4.54102 4.25313Z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SentIcon = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.0951 2.54206C3.02015 2.50548 2.93592 2.49232 2.85338 2.50431C2.77085 2.5163 2.69384 2.55288 2.6324 2.60929C2.57096 2.66569 2.52794 2.73929 2.50895 2.82051C2.48996 2.90172 2.49588 2.98677 2.52594 3.06456L4.8951 9.4204C5.03483 9.79559 5.03483 10.2085 4.8951 10.5837L2.52677 16.9396C2.49686 17.0173 2.49102 17.1022 2.51 17.1832C2.52898 17.2643 2.57191 17.3378 2.6332 17.3941C2.69449 17.4505 2.77132 17.4871 2.85369 17.4992C2.93607 17.5113 3.02018 17.4984 3.0951 17.4621L18.0951 10.3787C18.1665 10.345 18.2268 10.2917 18.269 10.225C18.3112 10.1583 18.3336 10.081 18.3336 10.0021C18.3336 9.92313 18.3112 9.84583 18.269 9.77914C18.2268 9.71246 18.1665 9.65914 18.0951 9.6254L3.0951 2.54206Z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 10H18.3333" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const UnreadIcon = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.3327 5.82812L10.8402 10.6006C10.5859 10.7483 10.2971 10.8261 10.0031 10.8261C9.70907 10.8261 9.42027 10.7483 9.16602 10.6006L1.66602 5.82812" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.666 3.32812H3.33268C2.41221 3.32812 1.66602 4.07432 1.66602 4.99479V14.9948C1.66602 15.9153 2.41221 16.6615 3.33268 16.6615H16.666C17.5865 16.6615 18.3327 15.9153 18.3327 14.9948V4.99479C18.3327 4.07432 17.5865 3.32812 16.666 3.32812Z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const StarredIcon = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.60404 1.91762C9.64056 1.84384 9.69697 1.78173 9.76692 1.73831C9.83686 1.69488 9.91755 1.67188 9.99987 1.67188C10.0822 1.67188 10.1629 1.69488 10.2328 1.73831C10.3028 1.78173 10.3592 1.84384 10.3957 1.91762L12.3207 5.81679C12.4475 6.07343 12.6347 6.29546 12.8662 6.46383C13.0977 6.6322 13.3666 6.74188 13.6499 6.78345L17.9549 7.41345C18.0364 7.42527 18.1131 7.45968 18.1761 7.51279C18.2391 7.56589 18.2861 7.63558 18.3116 7.71396C18.337 7.79234 18.3401 7.87629 18.3204 7.95632C18.3006 8.03634 18.2589 8.10925 18.1999 8.16679L15.0865 11.1985C14.8812 11.3985 14.7276 11.6455 14.6389 11.9181C14.5502 12.1908 14.5291 12.4809 14.5774 12.7635L15.3124 17.0468C15.3268 17.1283 15.318 17.2123 15.287 17.289C15.2559 17.3658 15.204 17.4323 15.137 17.481C15.07 17.5296 14.9907 17.5585 14.9081 17.5642C14.8255 17.5699 14.743 17.5524 14.6699 17.5135L10.8215 15.4901C10.568 15.357 10.2859 15.2874 9.99946 15.2874C9.71306 15.2874 9.43094 15.357 9.17737 15.4901L5.32987 17.5135C5.25681 17.5521 5.17437 17.5695 5.09191 17.5637C5.00946 17.5578 4.9303 17.5289 4.86345 17.4803C4.7966 17.4317 4.74473 17.3653 4.71375 17.2886C4.68277 17.212 4.67392 17.1282 4.68821 17.0468L5.42237 12.7643C5.47087 12.4816 5.44986 12.1913 5.36115 11.9185C5.27245 11.6457 5.11871 11.3986 4.91321 11.1985L1.79987 8.16762C1.74037 8.11015 1.6982 8.03712 1.67817 7.95685C1.65815 7.87658 1.66107 7.7923 1.6866 7.71361C1.71214 7.63492 1.75926 7.56499 1.8226 7.51177C1.88594 7.45856 1.96296 7.4242 2.04487 7.41262L6.34904 6.78345C6.63259 6.7422 6.90186 6.63267 7.13369 6.46428C7.36552 6.29588 7.55296 6.07368 7.67987 5.81679L9.60404 1.91762Z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ArchivedIcon = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5003 2.5H2.50033C2.04009 2.5 1.66699 2.8731 1.66699 3.33333V5.83333C1.66699 6.29357 2.04009 6.66667 2.50033 6.66667H17.5003C17.9606 6.66667 18.3337 6.29357 18.3337 5.83333V3.33333C18.3337 2.8731 17.9606 2.5 17.5003 2.5Z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.33301 6.66406V15.8307C3.33301 16.2728 3.5086 16.6967 3.82116 17.0092C4.13372 17.3218 4.55765 17.4974 4.99967 17.4974H6.66634" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.6663 6.66406V15.8307C16.6663 16.2728 16.4907 16.6967 16.1782 17.0092C15.8656 17.3218 15.4417 17.4974 14.9997 17.4974H13.333" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.5 12.5L10 10L12.5 12.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 10V17.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SpamIcon = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99935 18.3385C14.6017 18.3385 18.3327 14.6076 18.3327 10.0052C18.3327 5.40284 14.6017 1.67188 9.99935 1.67188C5.39698 1.67188 1.66602 5.40284 1.66602 10.0052C1.66602 14.6076 5.39698 18.3385 9.99935 18.3385Z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 6.67188V10.0052" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 13.3281H10.0083" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const TrashIcon = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.8327 5V16.6667C15.8327 17.1087 15.6571 17.5326 15.3445 17.8452C15.032 18.1577 14.608 18.3333 14.166 18.3333H5.83268C5.39065 18.3333 4.96673 18.1577 4.65417 17.8452C4.34161 17.5326 4.16602 17.1087 4.16602 16.6667V5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 5H17.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.66602 5.00521V3.33854C6.66602 2.89651 6.84161 2.47259 7.15417 2.16003C7.46673 1.84747 7.89065 1.67188 8.33268 1.67188H11.666C12.108 1.67188 12.532 1.84747 12.8445 2.16003C13.1571 2.47259 13.3327 2.89651 13.3327 3.33854V5.00521" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const DraftIcon = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.00065 18.3385C4.55862 18.3385 4.1347 18.163 3.82214 17.8504C3.50958 17.5378 3.33398 17.1139 3.33398 16.6719V3.33854C3.33398 2.89652 3.50958 2.47259 3.82214 2.16003C4.1347 1.84747 4.55862 1.67188 5.00065 1.67188H11.6673C11.9311 1.67145 12.1924 1.72321 12.4361 1.82419C12.6798 1.92516 12.9011 2.07334 13.0873 2.26021L16.0773 5.25021C16.2647 5.43647 16.4133 5.658 16.5146 5.90201C16.6158 6.14603 16.6677 6.40769 16.6673 6.67188V16.6719C16.6673 17.1139 16.4917 17.5378 16.1792 17.8504C15.8666 18.163 15.4427 18.3385 15.0007 18.3385H5.00065Z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.666 1.67188V5.83854C11.666 6.05956 11.7538 6.27152 11.9101 6.4278C12.0664 6.58408 12.2783 6.67187 12.4993 6.67187H16.666" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.33268 7.5H6.66602" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.3327 10.8281H6.66602" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.3327 14.1719H6.66602" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CustomFolderIcon = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5L9.16667 5H15.8333C16.2754 5 16.6993 5.17559 17.0118 5.48816C17.3244 5.80072 17.5 6.22464 17.5 6.66667V15.8333Z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const FOLDER_META = {
  inbox:    { labelKey: 'pages.email.folders.inbox',    Icon: InboxIcon },
  sent:     { labelKey: 'pages.email.folders.sent',     Icon: SentIcon },
  drafts:   { labelKey: 'pages.email.folders.drafts',   Icon: DraftIcon },
  archived: { labelKey: 'pages.email.folders.archived', Icon: ArchivedIcon },
  spam:     { labelKey: 'pages.email.folders.spam',     Icon: SpamIcon },
  trash:    { labelKey: 'pages.email.folders.trash',    Icon: TrashIcon },
  custom:   { labelKey: null,                           Icon: CustomFolderIcon },
};

const FolderItem = ({ id, icon: Icon, label, isActive, badge, onClick }) => (
  <div
    className={`email-folder-item ${isActive ? 'active' : ''}`}
    onClick={onClick}
    title={label}
  >
    <Icon className="folder-icon-svg" />
    <span className="folder-name">{label}</span>
    {badge > 0 && (
      <span className="folder-badge">{badge > 99 ? '99+' : badge}</span>
    )}
  </div>
);

const EmailSidebar = ({ onCompose, onAddAccount, mobileView, navigateToView }) => {
  const { t } = useI18n();
  const {
    accounts,
    activeAccountId,
    setActiveAccountId,
    folders,
    activeFolderId,
    setActiveFolderId,
    syncAccount,
    isSyncing,
    isFoldersLoading,
    createFolder,
    deleteFolder,
  } = useEmail();

  const [showMore, setShowMore] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [folderErrors, setFolderErrors] = useState({});

  const openCreateModal = () => {
    setNewFolderName('');
    setFolderErrors({});
    setShowCreateModal(true);
  };

  const closeCreateModal = () => {
    setNewFolderName('');
    setFolderErrors({});
    setShowCreateModal(false);
  };
  const [folderToDelete, setFolderToDelete] = useState(null); // { id, name }
  const [isDeleting, setIsDeleting] = useState(false);

  const handleCreateFolder = async (e) => {
    e.preventDefault();
    const name = newFolderName.trim();
    if (!name) return;
    setIsCreating(true);
    setFolderErrors({});
    try {
      await createFolder(name);
      notify('success', `Folder "${name}" created`); // folder-specific success, not translated per spec
      closeCreateModal();
      setShowMore(true);
    } catch (err) {
      if (err?.status === 422 && err?.errors) {
        setFolderErrors(err.errors);
      } else {
        notify('error', err?.message || 'Failed to create folder');
      }
    } finally {
      setIsCreating(false);
    }
  };

  const handleDeleteFolder = (e, folderId, folderName) => {
    e.stopPropagation();
    setFolderToDelete({ id: folderId, name: folderName });
  };

  const confirmDeleteFolder = async () => {
    if (!folderToDelete) return;
    setIsDeleting(true);
    try {
      await deleteFolder(folderToDelete.id);
      notify('success', `Folder "${folderToDelete.name}" deleted`);
      setFolderToDelete(null);
    } catch {
      notify('error', 'Failed to delete folder');
    } finally {
      setIsDeleting(false);
    }
  };

  const activeAccount = accounts.find((a) => a.id === activeAccountId);

  const handleAccountChange = (e) => {
    const value = e.target.value;
    if (value === 'add_account') {
      onAddAccount();
    } else {
      setActiveAccountId(Number(value));
    }
  };

  // Split folders into groups
  const inboxFolder = folders.filter((f) => f.type === 'inbox');
  const sentFolder = folders.filter((f) => f.type === 'sent');
  const draftFolder = folders.filter((f) => f.type === 'drafts');
  const moreFolders = folders.filter((f) => !['inbox', 'sent', 'drafts'].includes(f.type) && f.name !== 'Archive');

  const unreadBadge = folders.find((f) => f.type === 'inbox')?.unread_count ?? 0;

  return (
    <div className="email-sidebar">
      <div className="email-sidebar-header">
        <div className="email-sidebar-controls">
          <button 
              className="email-mobile-close-sidebar-btn" 
              onClick={() => navigateToView && navigateToView('list')}
              title="Close folders"
          >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
          </button>
          <select
            className="email-account-select"
            value={activeAccountId || ''}
            onChange={handleAccountChange}
          >
            {accounts.map((account) => (
              <option key={account.id} value={account.id}>
                {account.display_name || account.email}
              </option>
            ))}
            <option value="add_account">{t('pages.email.sidebar.add_account_option')}</option>
          </select>
          <button
            className="email-header-add-btn"
            onClick={onAddAccount}
            title={t('pages.email.sidebar.add_account')}
          >
            <img
              src={require('../../assets/plus.svg').default}
              alt={t('pages.email.sidebar.add_account')}
            />
          </button>
        </div>

        <button className="email-compose-btn" onClick={onCompose}>
          <img src={require('../../assets/pencil.svg').default} alt={t('pages.email.sidebar.compose')} />
          {t('pages.email.sidebar.compose')}
        </button>
      </div>

      <div className="email-folder-list">
        {isFoldersLoading ? (
          <div className="email-folder-skeleton-list">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="email-folder-skeleton-item">
                <div className="email-folder-skeleton-icon" />
                <div className="email-folder-skeleton-text" />
              </div>
            ))}
          </div>
        ) : <>
        {/* 1. Inbox */}
        {inboxFolder.map((folder) => (
          <FolderItem
            key={folder.id}
            icon={FOLDER_META.inbox.Icon}
            label={t(FOLDER_META.inbox.labelKey)}
            isActive={folder.id === activeFolderId}
            badge={folder.unread_count}
            onClick={() => {
                setActiveFolderId(folder.id);
                if (navigateToView) navigateToView('list');
            }}
          />
        ))}

        {/* 2. Unread */}
        <FolderItem
          key="__unread__"
          icon={UnreadIcon}
          label={t('pages.email.folders.unread')}
          isActive={activeFolderId === '__unread__'}
          badge={unreadBadge}
          onClick={() => {
              setActiveFolderId('__unread__');
              if (navigateToView) navigateToView('list');
          }}
        />

        {/* 3. Starred */}
        <FolderItem
          key="__starred__"
          icon={StarredIcon}
          label={t('pages.email.folders.starred')}
          isActive={activeFolderId === '__starred__'}
          badge={0}
          onClick={() => {
              setActiveFolderId('__starred__');
              if (navigateToView) navigateToView('list');
          }}
        />

        {/* 4. Sent */}
        {sentFolder.map((folder) => (
          <FolderItem
            key={folder.id}
            icon={FOLDER_META.sent.Icon}
            label={t(FOLDER_META.sent.labelKey)}
            isActive={folder.id === activeFolderId}
            badge={folder.unread_count}
            onClick={() => {
                setActiveFolderId(folder.id);
                if (navigateToView) navigateToView('list');
            }}
          />
        ))}

        {/* 5. Draft */}
        {draftFolder.map((folder) => (
          <FolderItem
            key={folder.id}
            icon={FOLDER_META.drafts.Icon}
            label={t(FOLDER_META.drafts.labelKey)}
            isActive={folder.id === activeFolderId}
            badge={folder.unread_count}
            onClick={() => {
                setActiveFolderId(folder.id);
                if (navigateToView) navigateToView('list');
            }}
          />
        ))}

        {/* More section — always shown (contains Archived + DB folders) */}
        <>
          <div
            className="email-folder-item email-folder-more-toggle"
            onClick={() => setShowMore((v) => !v)}
          >
            {showMore ? (
              <FaChevronUp className="folder-icon-svg" />
            ) : (
              <FaChevronDown className="folder-icon-svg" />
            )}
            <span className="folder-name">{showMore ? t('pages.email.sidebar.less') : t('pages.email.sidebar.more')}</span>
          </div>
          {showMore && (
            <>
              {/* Archived — special virtual filter */}
              <FolderItem
                key="__archived__"
                icon={ArchivedIcon}
                label={t('pages.email.folders.archived')}
                isActive={activeFolderId === '__archived__'}
                badge={0}
                onClick={() => {
                    setActiveFolderId('__archived__');
                    if (navigateToView) navigateToView('list');
                }}
              />
              {/* DB folders: spam → trash → custom */}
              {['spam', 'trash', 'custom'].flatMap((type) =>
                moreFolders
                  .filter((f) => f.type === type)
                  .map((folder) => {
                    const meta = FOLDER_META[folder.type] || FOLDER_META.custom;
                    const label = meta.labelKey ? t(meta.labelKey) : folder.name;
                    const isCustom = folder.type === 'custom';
                    return (
                      <div
                        key={folder.id}
                        className={`email-folder-item email-folder-item--with-delete ${folder.id === activeFolderId ? 'active' : ''}`}
                        onClick={() => {
                            setActiveFolderId(folder.id);
                            if (navigateToView) navigateToView('list');
                        }}
                      >
                        <meta.Icon className="folder-icon-svg" />
                        <span className="folder-name">{label}</span>
                        {folder.unread_count > 0 && (
                          <span className="folder-badge">{folder.unread_count}</span>
                        )}
                        {isCustom && (
                          <button
                            className="email-folder-delete-btn"
                            onClick={(e) => handleDeleteFolder(e, folder.id, folder.name)}
                            title="Delete folder"
                          >
                            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M16.875 3.75H13.75V3.125C13.75 2.62772 13.5525 2.15081 13.2008 1.79917C12.8492 1.44754 12.3723 1.25 11.875 1.25H8.125C7.62772 1.25 7.15081 1.44754 6.79917 1.79917C6.44754 2.15081 6.25 2.62772 6.25 3.125V3.75H3.125C2.95924 3.75 2.80027 3.81585 2.68306 3.93306C2.56585 4.05027 2.5 4.20924 2.5 4.375C2.5 4.54076 2.56585 4.69973 2.68306 4.81694C2.80027 4.93415 2.95924 5 3.125 5H3.75V16.25C3.75 16.5815 3.8817 16.8995 4.11612 17.1339C4.35054 17.3683 4.66848 17.5 5 17.5H15C15.3315 17.5 15.6495 17.3683 15.8839 17.1339C16.1183 16.8995 16.25 16.5815 16.25 16.25V5H16.875C17.0408 5 17.1997 4.93415 17.3169 4.81694C17.4342 4.69973 17.5 4.54076 17.5 4.375C17.5 4.20924 17.4342 4.05027 17.3169 3.93306C17.1997 3.81585 17.0408 3.75 16.875 3.75ZM7.5 3.125C7.5 2.95924 7.56585 2.80027 7.68306 2.68306C7.80027 2.56585 7.95924 2.5 8.125 2.5H11.875C12.0408 2.5 12.1997 2.56585 12.3169 2.68306C12.4342 2.80027 12.5 2.95924 12.5 3.125V3.75H7.5V3.125ZM15 16.25H5V5H15V16.25ZM8.75 8.125V13.125C8.75 13.2908 8.68415 13.4497 8.56694 13.5669C8.44973 13.6842 8.29076 13.75 8.125 13.75C7.95924 13.75 7.80027 13.6842 7.68306 13.5669C7.56585 13.4497 7.5 13.2908 7.5 13.125V8.125C7.5 7.95924 7.56585 7.80027 7.68306 7.68306C7.80027 7.56585 7.95924 7.5 8.125 7.5C8.29076 7.5 8.44973 7.56585 8.56694 7.68306C8.68415 7.80027 8.75 7.95924 8.75 8.125ZM12.5 8.125V13.125C12.5 13.2908 12.4342 13.4497 12.3169 13.5669C12.1997 13.6842 12.0408 13.75 11.875 13.75C11.7092 13.75 11.5503 13.6842 11.4331 13.5669C11.3158 13.4497 11.25 13.2908 11.25 13.125V8.125C11.25 7.95924 11.3158 7.80027 11.4331 7.68306C11.5503 7.56585 11.7092 7.5 11.875 7.5C12.0408 7.5 12.1997 7.56585 12.3169 7.68306C12.4342 7.80027 12.5 7.95924 12.5 8.125Z" fill="#DE1414"/>
                            </svg>
                          </button>
                        )}
                      </div>
                    );
                  })
              )}
            </>
          )}
        </>

        {folders.length === 0 && (
          <div className="email-folder-empty">{t('pages.email.sidebar.no_folders')}</div>
        )}
        </>}

        {/* Create Folder row */}
        <div className="email-create-folder-row" onClick={openCreateModal}>
          <span className="email-create-folder-label">{t('pages.email.sidebar.create_folder')}</span>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 3.75V14.25M3.75 9H14.25" stroke="#0c5097" strokeWidth="1.75" strokeLinecap="round"/>
          </svg>
        </div>
      </div>

      {/* Create Folder Modal */}
      {showCreateModal && ReactDOM.createPortal(
        <div className="project-composer-overlay" onClick={closeCreateModal}>
          <div className="project-composer-modal email-create-folder-modal" onClick={(e) => e.stopPropagation()}>
            <div className="project-composer-header">
              <h2 className="project-composer-title">{t('pages.email.create_folder.title')}</h2>
              <button className="project-composer-close" onClick={closeCreateModal} aria-label="Close">
                <FaTimes size={16} />
              </button>
            </div>
            <form onSubmit={handleCreateFolder}>
              <div className="project-composer-body">
                <div className="project-form-group">
                  <label className="project-form-label">{t('pages.email.create_folder.name_label')} <span className="required">*</span></label>
                  <input
                    className={`project-form-input ${folderErrors.name ? 'is-invalid' : ''}`}
                    type="text"
                    placeholder={t('pages.email.create_folder.name_placeholder')}
                    value={newFolderName}
                    onChange={(e) => {
                      setNewFolderName(e.target.value);
                      if (folderErrors.name) setFolderErrors({});
                    }}
                    autoFocus
                    maxLength={100}
                  />
                  {folderErrors.name && <div className="field-error">{folderErrors.name[0]}</div>}
                </div>
              </div>
              <div className="project-composer-footer">
                <button type="button" className="project-composer-btn project-composer-btn-secondary" onClick={closeCreateModal}>
                  {t('pages.email.create_folder.cancel')}
                </button>
                <button type="submit" className="project-composer-btn project-composer-btn-primary" disabled={isCreating || !newFolderName.trim()}>
                  {isCreating ? t('pages.email.create_folder.creating') : t('pages.email.create_folder.create')}
                </button>
              </div>
            </form>
          </div>
        </div>,
        document.body
      )}

      {/* Delete Folder Confirmation Modal */}
      {folderToDelete && ReactDOM.createPortal(
        <div className="delete-project-modal-overlay" onClick={() => !isDeleting && setFolderToDelete(null)}>
          <div className="delete-project-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="delete-project-modal-close"
              onClick={() => setFolderToDelete(null)}
              disabled={isDeleting}
              aria-label="Close"
            >
              <FaTimes size={9.33} />
            </button>
            <div className="delete-project-modal-header">
              <div className="delete-project-modal-header-left">
                <img className="delete-project-modal-small-icon" src={trashIcon} alt="Delete" />
                <h2 className="delete-project-modal-title">{t('pages.email.delete_folder.title')}</h2>
              </div>
            </div>
            <p className="delete-project-modal-description">
              {t('pages.email.delete_folder.confirm_prefix')} <strong>"{folderToDelete.name}"</strong> {t('pages.email.delete_folder.confirm_suffix')}
            </p>
            <div className="delete-project-modal-actions">
              <button
                className="delete-project-modal-cancel"
                onClick={() => setFolderToDelete(null)}
                disabled={isDeleting}
              >
                {t('pages.email.delete_folder.cancel')}
              </button>
              <button
                className="delete-project-modal-delete"
                onClick={confirmDeleteFolder}
                disabled={isDeleting}
              >
                {isDeleting ? t('pages.email.delete_folder.deleting') : t('pages.email.delete_folder.delete')}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <div className="email-sidebar-footer">
        <button
          className={`email-sync-btn ${isSyncing ? 'syncing' : ''}`}
          onClick={syncAccount}
          disabled={isSyncing}
        >
          <FaSync className={isSyncing ? 'spin' : ''} size={14} />
          {isSyncing ? t('pages.email.sidebar.syncing') : t('pages.email.sidebar.sync')}
        </button>

        {activeAccount?.last_sync_at && (
          <div className="email-last-sync">
            {t('pages.email.sidebar.last_synced')}:{' '}
            {new Date(activeAccount.last_sync_at).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false,
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailSidebar;
